import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { transactionQueries } from '../api/transaction-queries';
import type { OptionsFilter } from '../api/transaction-api';
import type { TransactionsListFilter } from '../lib/filters';

type OptionsQuery = Omit<OptionsFilter, 'skip'>;

/** The transactions list: rows, summary stats and the total count. */
export function useTransactions(filter: TransactionsListFilter) {
  return useQuery(transactionQueries.list(filter));
}

/** Infinite, searchable client options for the filters modal. */
export function useTransactionClientOptions(filter: OptionsQuery, enabled: boolean) {
  return useInfiniteQuery(transactionQueries.clientOptions(filter, enabled));
}

/** Infinite, searchable bonus options for the filters modal. */
export function useTransactionBonusOptions(filter: OptionsQuery, enabled: boolean) {
  return useInfiniteQuery(transactionQueries.bonusOptions(filter, enabled));
}

/** Infinite, searchable foul-template options for the filters modal. */
export function useTransactionFoulOptions(filter: OptionsQuery, enabled: boolean) {
  return useInfiniteQuery(transactionQueries.foulOptions(filter, enabled));
}
